import { Box, FormControl, RadioGroup, FormControlLabel, Radio, Divider, Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos, CheckCircleOutline, WarningAmberOutlined } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import useLoading from "../../hooks/useLoading";
import SettingsStoreList from './SettingsStoreList';
import useShowMessages from "../../hooks/useShowMessages";

const SettingsStoreItem = ({ onClose, openSuccessModal, updateSetting, settingSelected, confirmationModal, setConfirmationModal }) => {
  const [settingValue, setSettingValue] = useState('');
  const [temporaryValue, setTemporaryValue] = useState('');
  const [showStoreList, setShowStoreList] = useState(false);
  const { setIsLoading } = useLoading();
  const [ settingLabel, setSettingLabel ] = useState('')
  const { showMessage } = useShowMessages();

  const closeList = () => {
    setShowStoreList(false);
  }

  const handleChange = async (event) => {
    try {
      const radioValue = event.target.value;
      if (radioValue !== 'list') {
        setTemporaryValue(radioValue);
        setIsLoading(true);
        setConfirmationModal(true);
      } else {
        setSettingValue(radioValue);
      }
    } catch (error) {
      showMessage(
        "Setting couldn't be updated.",
        "error"
      );
    }
  }

  useEffect(() => {
    const { currentValue, label } = settingSelected;
    setSettingLabel(label)
    switch(currentValue) {
      case 'Active at all stores':
        setSettingValue('all')
        break;
      case 'Active at selected stores':
        setSettingValue('list')
        break;
      default:
        setSettingValue('none')
        break;
    }
  },[settingSelected])

  const handleConfirmation = (selection) => {
    if (selection) {
      setSettingValue(temporaryValue);
      updateSetting(temporaryValue);
      openSuccessModal()
      onClose()
    }
      setIsLoading(false);
      setConfirmationModal(false);
  };

  return (
    <Box sx={{ marginTop: "30px" }}>
      {showStoreList ? (
        <SettingsStoreList
          onClose={closeList}
          settingLabel={settingLabel}
          settingSelected={settingSelected}
          openSuccessModal={openSuccessModal}
          closeSettings={onClose}
          updateSetting={updateSetting}
        />
      ) : (
        <>
          <div className="mb-16 cursor-pointer" onClick={onClose}>
            <ArrowBackIos fontSize="small" />
            <span>Settings</span>
          </div>
          <div className="title-container">{settingLabel} settings</div>
          <Box
            className="settings-box"
            sx={{
              border: "1px solid",
              borderColor: "grey.300",
              borderRadius: 1,
              backgroundColor: "white",
            }}
          >
            <FormControl fullWidth>
              <RadioGroup
                defaultValue="list"
                name="radio-buttons-group"
                value={settingValue}
                onChange={handleChange}
                sx={{ padding: "10px" }}
              >
                <FormControlLabel
                  value="all"
                  control={<Radio size="small" color="success" />}
                  label="Active in all stores"
                  sx={{ padding: "10px" }}
                />
                <Divider sx={{ width: "96%", margin: "auto" }} />
                <FormControlLabel
                  value="none"
                  control={<Radio size="small" color="success" />}
                  label="Inactive in all stores"
                  sx={{ padding: "10px" }}
                />
                <Divider sx={{ width: "96%", margin: "auto" }} />
                <FormControlLabel
                  value="list"
                  control={<Radio size="small" color="success" />}
                  label={(
                    <div style={{ display: "flex", alignItems: "center" }}>
                      Active at selected stores
                      <div
                        className={`absolute right-8 ${settingValue !== "list"
                            ? "settings-disabled-text"
                            : "settings-enabled-text"
                          }`}
                        onClick={() =>
                          settingValue === "list" ? setShowStoreList(true) : null
                        }
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span>Manage stores</span>
                        <ArrowForwardIos />
                      </div>
                    </div>
                  )}
                  sx={{ padding: "10px" }}
                />
              </RadioGroup>
            </FormControl>
          </Box>
          {confirmationModal && (
              <Dialog
              sx={{
                '& .MuiDialog-paper': {
                  width: '80%',
                  maxHeight: 435,
                  backgroundColor: '#fffee8', // Light yellow background
                  color: '#E38017', // Dark yellow text for warning
                  fontWeight: 400,
                },
              }}
              maxWidth="xs"
              open={confirmationModal}
            >
              <DialogContent sx={{ display: 'flex', alignItems: 'center' }}>
                <WarningAmberOutlined fontSize="large" sx={{ mr: 2, color: '#EB7E0B' }} /> {/* Adjust icon color */}
                Are you sure you want to apply the selection to all stores?
              </DialogContent>
              <DialogActions>
                <Button onClick={() => handleConfirmation(true)} autoFocus sx={{ color: '#EB7E0B' }}>
                  Yes
                </Button>
                <Button onClick={() => handleConfirmation(false)} autoFocus sx={{ color: '#EB7E0B' }}>
                  No
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </>
      )}
    </Box>
  );
}

export default SettingsStoreItem;
